var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flashcard',{attrs:{"front":"STARFIT (SWIFT)","back":"iPhone application's purpose is to keep track of user's daily caloric intake.\n        Displays user's daily and weekly average calories.\n        Demonstrated ability to write software for a functional application.","headerFront":"","headerBack":"","footerFront":"","footerBack":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd64f16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StarFit.vue
// module id = null
// module chunks = 